import { Box } from '@ace-clublabs/shared-component-library';

import { useCallback, useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';
import ContactInfoForm from '@/components/shared/ContactInfoForm';
import { useAppointmentCreation } from '@/features/confirmation/api/useAppointmentCreation';
import useLandingPageRedirection from '@/hooks/useLandingPageRedirection';
import useProgress from '@/hooks/useProgress';
import { Page } from '@/lib/tagging';
import useTagging from '@/lib/tagging/useTagging';
import { selectTrvEndLocationForTagging } from '@/lib/tagging/utils';
import useAppointmentStore, {
  isInBranchAppointment as isInBranchAppointmentSelected,
  isOnlineAppointment as isOnlineAppointmentSelected,
} from '@/store/AppointmentStore';
import useSessionStore from '@/store/SessionStore';

const ContactInfo = () => {
  const hasTagged = useRef(false);

  useProgress(80);

  const trvEndLocation = useAppointmentStore(selectTrvEndLocationForTagging);

  const { sessionSource, sessionId, flowType } = useSessionStore();

  const isInBranchAppointment = useAppointmentStore(
    isInBranchAppointmentSelected,
  );
  const isOnlineAppointment = useAppointmentStore(isOnlineAppointmentSelected);

  const tagging = useTagging();

  useLandingPageRedirection();

  const navigate = useNavigate();

  useEffect(() => {
    if (!hasTagged.current) {
      const taggingData = {
        page: Page.contactInfo,
        sessionid: sessionId,
        flow: flowType,
        trv_end_location: trvEndLocation,
        comm_pref: isOnlineAppointment
          ? 'phone'
          : isInBranchAppointment
            ? 'in person'
            : undefined,
      };

      tagging.tag('view', sessionSource, taggingData);

      hasTagged.current = true;
    }
  }, [
    tagging.tag,
    sessionSource,
    sessionId,
    flowType,
    trvEndLocation,
    isOnlineAppointment,
    isInBranchAppointment,
  ]);

  const { handleStartAppointmentCreation } = useAppointmentCreation();

  const handleSubmit = useCallback(() => {
    handleStartAppointmentCreation();
    navigate('/confirmation', { replace: true });
  }, [handleStartAppointmentCreation, navigate]);

  return (
    <Box
      sx={[
        {
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'background.default',
        },
      ]}
    >
      <ContactInfoForm onSubmit={handleSubmit} />
    </Box>
  );
};

export default ContactInfo;
